import { Navigate } from 'react-router-dom';

import { matchCompanySubdomain } from './helpers';
import { removeLocalStorageToken } from './helpers/localStorage';
import { isFullAccessRole } from './helpers/roleAccess';
import { useStoragedJwt } from './hooks/useDecodedJwt';

export default function PrivateRoute({
  children,
  allowedRoles,
}: {
  children: React.ReactElement;
  /**
   * Papéis (role) autorizados a esta rota. admin sempre passa. `undefined` =
   * sem gating por papel (comportamento antigo). Protege deep-link; o
   * esconder do menu/abas é a barreira principal (RBAC REAL-3099).
   */
  allowedRoles?: number[];
}): JSX.Element {
  try {
    const decoded = useStoragedJwt();
    const companySubdomain = matchCompanySubdomain();

    if (decoded === null || decoded.expired) {
      removeLocalStorageToken();
      return <Navigate to="/login" />;
    }

    const companyData = decoded.user.companies.find(
      (company) => company.subdomain === companySubdomain
    );

    const role = companyData?.role;
    if (
      allowedRoles &&
      !isFullAccessRole(role) &&
      (role == null || !allowedRoles.includes(role))
    ) {
      return <Navigate to="*" />;
    }
    return children;
  } catch {
    return <Navigate to="/login" />;
  }
}
